import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import GBColorPropType from '../../prop-types/GBColor';
import styles from './pill.css';
var cx = classnames.bind(styles);
export default function Pill(_ref) {
  var _cx;

  var active = _ref.active,
      Element = _ref.as,
      className = _ref.className,
      color = _ref.color,
      label = _ref.label,
      role = _ref.role,
      props = _objectWithoutProperties(_ref, ["active", "as", "className", "color", "label", "role"]);

  return React.createElement(Element, _extends({
    className: cx('pill', (_cx = {}, _defineProperty(_cx, color, styles[color]), _defineProperty(_cx, "bordered", !active), _cx), className),
    role: role
  }, props), label);
}
Pill.propTypes = {
  active: PropTypes.bool,
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  className: PropTypes.string,
  color: GBColorPropType,
  label: PropTypes.string,
  role: PropTypes.string
};
Pill.defaultProps = {
  active: false,
  as: 'span',
  className: undefined,
  color: 'grey',
  label: null,
  role: 'span'
};